var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSalesLevel5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 14,
    viewBox: "0 0 93 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.605 1.868L1.415 9.854A1.578 1.578 0 001.577 13h77.715A8.967 8.967 0 0177 7c0-1.907.593-3.676 1.605-5.132z",
    fill: "#82CC82"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 7,
    r: 7,
    fill: "#007200"
  })));
}

export default SvgSalesLevel5;